import { dataAttribute, DataAttributes } from "@bps/fluent-ui";
import { FilterBar } from "@ui-components/filter-bar/FilterBar.tsx";
import { FilterBarProps } from "@ui-components/filter-bar/FilterBar.types.ts";
import { usePatientLabel } from "@ui-components/hooks/usePatientLabel.ts";

type CommunicationHistoryFilterProps = Pick<
  FilterBarProps<CommunicationHistoryFilterState>,
  "children"
>;

export interface CommunicationHistoryFilterState {
  search?: string;
}

export const CommunicationHistoryFilter: React.FC<
  CommunicationHistoryFilterProps
> = ({ children }) => {
  const items: FilterBarProps<CommunicationHistoryFilterState>["items"] = [
    {
      type: "searchBox",
      name: "search",
      stickItem: true,
      props: {
        removeSpecialCharacters: false,
        autoFocus: true,
        placeholder: `Search for ${usePatientLabel(false)}`,
        styles: {
          clearButton: { display: "none" },
          root: { width: 400 }
        }
      }
    }
  ];
  return (
    <FilterBar<CommunicationHistoryFilterState>
      items={items}
      initialValues={undefined}
      {...dataAttribute(DataAttributes.Element, "communicationHistory-filter")}
    >
      {children}
    </FilterBar>
  );
};
